import React, { memo } from 'react';
import { Box, Button, Image, Text } from '@betty/moonlight';
import { DailyGiftPendingProps } from './DailyGiftPending.types';

function DailyGiftPending({ handleClaim, isClaiming }: DailyGiftPendingProps) {
  return (
    <Box
      alignItems="center"
      gap="space-600"
      height="100%"
      justifyContent="space-between"
    >
      <Text
        variant="h4"
        color="accentSurfacePrimary"
        locNS="dailyGift"
        locKey="pendingTitle"
        textAlign="center"
      />
      <Image name="common.BettyCoinStack" width={200} height={155} />
      <Button
        width="100%"
        light
        variant="primary"
        locNS="dailyGift"
        locKey="pendingCta"
        onPress={handleClaim}
        loading={isClaiming}
      />
    </Box>
  );
}

export default memo(DailyGiftPending);
